import { delay, NAVIGATION_SETTLE_MS } from '../domLocator'
import { ClientTool } from '../Tool'

interface Input extends Record<string, unknown> {
  templateId: string
}

const navigateToTemplate: ClientTool = {
  name: 'navigate_to_template',
  category: 'navigate',
  execute: async (rawInput, ctx) => {
    const { templateId } = rawInput as Input
    ctx.navigate(`/templates/plan/${templateId}`)
    await delay(NAVIGATION_SETTLE_MS)
    return {
      success: true,
      content: `Navigation complete. Current URL: ${ctx.getPathname()}`
    }
  },
  getStepLabel: () => 'Navigating to template…'
}

export default navigateToTemplate
